module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



// WEBPACK FOOTER //
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/core-js/internals/array-buffer-native.js